/* eslint ember/no-new-mixins:"off" */

// TODO: this mixin is being deprecated in favor of frontend/@dashboard/user/addon/services/user-subscriptions.ts
//       any changes here need to be backported to that new service

import Mixin from '@ember/object/mixin';
import { alias, readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
export default Mixin.create({
  // appease typescript which can't infer that `service()` will result in us having a property with
  // type UserSubscriptions by first casting to `unknown`. Mixin's can't be defined as native classes
  // so the normal `@service userSubscriptions!: UserSubscriptions;` syntax is not avialable here.
  userSubscriptions: service(),
  // eslint-disable-line ember/avoid-leaking-state-in-ember-objects

  subscriptionFeatureStatus: alias('userSubscriptions.subscriptionFeatureStatus'),
  isSubscribedToMarketing: alias('userSubscriptions.isSubscribedToMarketing'),
  isMarketingPaused: alias('userSubscriptions.isMarketingPaused'),
  isSubscribedToLoyalty: alias('userSubscriptions.isSubscribedToLoyalty'),
  setRSTFreeTrialJustStarted() {
    return this.userSubscriptions.setRSTFreeTrialJustStarted();
  },
  updateSubscriptionFeatures(newFeatures) {
    return this.userSubscriptions.updateSubscriptionFeatures(newFeatures);
  },
  getSubscriptionFeatureStatus(feature) {
    return this.userSubscriptions.getSubscriptionFeatureStatus(feature);
  },
  subscriptionFeatureIsEnabled(feature) {
    return this.userSubscriptions.subscriptionFeatureIsEnabled(feature);
  },
  subscriptionFeatureInFreeTrial(feature) {
    return this.userSubscriptions.subscriptionFeatureInFreeTrial(feature);
  },
  subscriptionFeatureIsStatus(feature, status) {
    return this.userSubscriptions.subscriptionFeatureIsStatus(feature, status);
  },
  isSubscribedToRetailPlus: alias('userSubscriptions.isSubscribedToRetailPlus'),
  canRetailerSeeItemOptions: alias('userSubscriptions.canRetailerSeeItemOptions'),
  isSubscribedToRetailFree: alias('userSubscriptions.isSubscribedToRetailFree'),
  isRetailFreeTrialNoObligation: alias('userSubscriptions.isRetailFreeTrialNoObligation'),
  wasSubscribedToRestaurants: alias('userSubscriptions.wasSubscribedToRestaurants'),
  isRestaurantsFreeTierUser: readOnly('userSubscriptions.isRestaurantsFreeTierUser'),
  isSubscribedToRetail: alias('userSubscriptions.isSubscribedToRetail'),
  isOrWasSubscribedToRestaurants: alias('userSubscriptions.isOrWasSubscribedToRestaurants'),
  canSeeAutoGratuitiesReporting: alias('userSubscriptions.canSeeAutoGratuitiesReporting'),
  canUseAdvancedInventory: alias('userSubscriptions.canUseAdvancedInventory'),
  isSubscribedToEmployeeManagement: alias('userSubscriptions.isSubscribedToEmployeeManagement'),
  isSubscribedToAppointments: alias('userSubscriptions.isSubscribedToAppointments')
});